/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { NamedNumericValueDto } from './NamedNumericValueDto';
import {
    NamedNumericValueDtoFromJSON,
    NamedNumericValueDtoFromJSONTyped,
    NamedNumericValueDtoToJSON,
} from './NamedNumericValueDto';

/**
 * 
 * @export
 * @interface NumericDataSetSetupDto
 */
export interface NumericDataSetSetupDto {
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    dataTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    iuid: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericDataSetSetupDto
     */
    origin: EntityOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof NumericDataSetSetupDto
     */
    isIdenticalOverAllSetupValues: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NumericDataSetSetupDto
     */
    isIdenticalForSameDataType: boolean;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericDataSetSetupDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof NumericDataSetSetupDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataSetSetupDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {Array<NamedNumericValueDto>}
     * @memberof NumericDataSetSetupDto
     */
    readonly values?: Array<NamedNumericValueDto> | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetSetupDto
     */
    $type?: NumericDataSetSetupDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataSetSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataSetSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataSetSetupDtoTypeEnum = typeof NumericDataSetSetupDtoTypeEnum[keyof typeof NumericDataSetSetupDtoTypeEnum];



/**
 * Check if a given object implements the NumericDataSetSetupDto interface.
 */
export function instanceOfNumericDataSetSetupDto(value?: unknown): value is NumericDataSetSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataSetSetupDtoTypeEnum)[0];
}

export function NumericDataSetSetupDtoFromJSON(json: any): NumericDataSetSetupDto {
    return NumericDataSetSetupDtoFromJSONTyped(json, false);
}

export function NumericDataSetSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataSetSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'dataTypeId': json['dataTypeId'],
        'iuid': json['iuid'],
        'origin': EntityOriginFromJSON(json['origin']),
        'isIdenticalOverAllSetupValues': json['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': json['isIdenticalForSameDataType'],
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(NamedNumericValueDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericDataSetSetupDtoToJSON(value?: Omit<NumericDataSetSetupDto, 'values'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'dataTypeId': value['dataTypeId'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'isIdenticalOverAllSetupValues': value['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': value['isIdenticalForSameDataType'],
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        'unitAbbreviation': value['unitAbbreviation'],
        'valueType': CreateDefinitionDtoValueTypeToJSON(value['valueType']),
        'decimalPlaces': value['decimalPlaces'],
        '$type': value['$type'],
    });
}

